import {
    faBank,
    faGift,
    faMoneyBill,
    faMoneyBillTransfer,
    faQrcode,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function TransferMoney() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const transferOptions = [
    {
        title: t('TRANSFER_BETWEEN_ACCOUNTS'),
        icon: faMoneyBillTransfer,
        action: () => {
            navigate("/transfer-wallets")
        }
    }, 
    {
        title: t('TRANSFER_USERNAME'),
        icon: faUser,
        action: () => {
            navigate("/transfer-username")
        }
    },
    {
        title: t('NAV_GIFT_CARD'),
        icon: faGift,
        action: () => {
            navigate("/gift-cards")
        }
    },
    {
        title: t('TRANSFER_QR_CODE'),
        icon: faQrcode,
        action: () => {
            navigate("/transfer-qr-code")
        }
    },
    {
        title: t('TRANSFER_WITHDRAW_BANK'),
        icon: faBank,
        action: () => {
            //navigate("/transfer-withdraw-bank")
        }
    },
    {
        title: t('TRANSFER_WITHDRAW_CASH'),
        icon: faMoneyBill,
        action: () => {
            navigate("/transfer-withdraw-cash")
        }
    }
  ]

  return (
    <>
      <Toolbar title={t("DASHBOARD_TRANSFER_MONEY")} showBackBtn={true} />
      <div>
        <div className="flex w-full justify-center">
          <div className="container grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-5 mx-7">
            {transferOptions.map(it => (
                <div className="col-span-1 bg-card text-white p-4 flex flex-col items-center justify-center cursor-pointer h-[10rem]" onClick={it.action}>
                    <FontAwesomeIcon icon={it.icon} className="card-icon pt-5" size={"2xl"} />
                    <h4 className="font-medium pb-5 pt-2">{it.title}</h4>
                </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default TransferMoney;
